import { createSlice } from '@reduxjs/toolkit';

/** Defaults when no localStorage (matches App Settings panel defaults). */
export const DEFAULT_APP_SETTINGS = {
  appTheme: 'orange',
  appDarkMode: false,
  appGradientEnabled: true,
  appHeaderFixed: false,
  appHeaderInverse: false,
  appSidebarFixed: false,
  appSidebarGrid: false,
};

// Load settings from localStorage
const loadSettings = () => {
  try {
    const storedSettings = localStorage.getItem('appSettings');
    if (storedSettings) {
      return JSON.parse(storedSettings);
    }
  } catch (error) {
    console.error('Error loading app settings from localStorage:', error);
  }

  return { ...DEFAULT_APP_SETTINGS };
};

// Save settings to localStorage
const saveSettings = (settings) => {
  try {
    localStorage.setItem('appSettings', JSON.stringify(settings));
  } catch (error) {
    console.error('Error saving app settings to localStorage:', error);
  }
};

const initialState = loadSettings();

const appSettingsSlice = createSlice({
  name: 'appSettings',
  initialState,
  reducers: {
    setAppTheme: (state, action) => {
      state.appTheme = action.payload;
      saveSettings(state);
    },
    setAppDarkMode: (state, action) => {
      state.appDarkMode = action.payload;
      saveSettings(state);
    },
    setAppGradientEnabled: (state, action) => {
      state.appGradientEnabled = action.payload;
      saveSettings(state);
    },
    setAppHeaderFixed: (state, action) => {
      state.appHeaderFixed = action.payload;
      saveSettings(state);
    },
    setAppHeaderInverse: (state, action) => {
      state.appHeaderInverse = action.payload;
      saveSettings(state);
    },
    setAppSidebarFixed: (state, action) => {
      state.appSidebarFixed = action.payload;
      saveSettings(state);
    },
    setAppSidebarGrid: (state, action) => {
      state.appSidebarGrid = action.payload;
      saveSettings(state);
    },
    resetAppSettings: (state) => {
      Object.assign(state, { ...DEFAULT_APP_SETTINGS });
      saveSettings(state);
    },
  },
});

export const {
  setAppTheme,
  setAppDarkMode,
  setAppGradientEnabled,
  setAppHeaderFixed,
  setAppHeaderInverse,
  setAppSidebarFixed,
  setAppSidebarGrid,
  resetAppSettings,
} = appSettingsSlice.actions;

export default appSettingsSlice.reducer;
